module.exports = __webpack_public_path__ + "static/img/title.ce04d0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/inno/title.jpg
// module id = 407
// module chunks = 1